import React from 'react';
import { useLocation } from 'umi';
import { PAGE_CONFIG_API } from '@home/_config/constant';
import CommonPageRender from '@home/components/CommonPageRender';
import type { IPageConfigType } from '@/pages/dashboard/components/PageContainer/type';
import type { IStudioData } from '../type';
import { DATABRAIN_LINK_PAGE_PATH } from '../constant';
import { PAGE_CONFIG } from './pageConfig';
import './index.scss';

interface IDatabrainLinkProps {
  /** 由 StudioWrap / GameWrap 透传的专区数据，用于定位当前 Databrain Page */
  studioData?: IStudioData;
}

const DatabrainLink = (props: IDatabrainLinkProps) => {
  const { studioData } = props || {};
  const location = useLocation();
  const pageConfigInit = PAGE_CONFIG as unknown as IPageConfigType;

  return (
    <CommonPageRender
      key={`${location.pathname}${location.search}`}
      className="dbh-studio-databrain-link"
      reqParams={`/${DATABRAIN_LINK_PAGE_PATH}`}
      frameType="game"
      pageConfigInit={pageConfigInit}
      api={PAGE_CONFIG_API}
      studioData={studioData}
    />
  );
};

export default DatabrainLink;
